
import React, { useEffect } from 'react';
import { Button } from 'antd';

import { t } from '../../languages';
import { recordPageGA } from '../../modules/ga';
import { PlusOutlined } from '@ant-design/icons';

const CreateCompetitionButton = ({ lang, modalOption }) => {
  return (
    <section className="join-create-buttons">
      <Button type="primary" className="button-blue" onClick={e=>modalOption('createCompetition')}>
        <PlusOutlined />{t(lang, 'createCompetition')}
      </Button>
    </section>
  );
};

export default CreateCompetitionButton;


